"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StrategyHero() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: copyRef,
    isVisible: copyVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section className="relative flex min-h-screen w-full items-center justify-center overflow-hidden bg-white">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-fixed bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1454827/img/strategy_hero_background.png)]" aria-hidden="true" />
      <div className="absolute inset-0 bg-dark-background/60" aria-hidden="true" />

      {}
      <div className="relative z-10 mx-auto max-w-4xl px-6 py-24 text-center">
        {}
        <h1 ref={headlineRef} className={`font-display text-5xl font-bold leading-tight text-foreground-dark transition-all duration-700 ease-[var(--ease-smooth)] md:text-6xl lg:text-7xl ${headlineVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          Purpose-Built Real Estate for Regulated Sectors
        </h1>

        {}
        <p ref={copyRef} className={`mt-6 font-sans text-lg leading-relaxed text-foreground-dark/90 transition-all delay-100 duration-700 ease-[var(--ease-smooth)] md:text-xl ${copyVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          Haven Holdings Capital delivers turn-key, triple-net properties with disciplined
          underwriting and risk-adjusted returns.
        </p>

        {}
        <div ref={ctaRef} className={`mt-10 transition-all delay-200 duration-700 ease-[var(--ease-smooth)] ${ctaVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <Button asChild size="lg" className="hover-lift rounded-md bg-primary px-8 py-4 text-base font-semibold text-foreground-primary shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:bg-primary-hover hover:shadow-strong focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
            <Link to="/InvestmentStrategyPage">
              Explore Our Investment Strategy
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}